import { FC } from 'react';
import { Box } from '@mui/material';
import { SharedResourceTabs } from '@client/features/shared-resources/shared-resource-tabs';
import { TemplateGrid } from './template-grid';
import {
  SignalBlockTarget,
  TemplateType
} from '@server/trading-templates/schemas/input.schema';

export type ManageTradingTemplatesProps = {
  templateType: TemplateType;
  onApply: (templateIds: string[]) => void;
  onAdd?: (templateIds: string[]) => void;
  onDelete: (templateIds: string[]) => void;
  onSetAsDefault: (templateId: string, isDefault: boolean) => void;
  onModify?: (templateId: string, templateName: string) => void;
  onDuplicate?: (templateId: string, templateName: string) => void;
  onShare?: (templateId: string, templateName: string) => void;
  onImportShared: (
    sharedResourceId: string,
    sharedResourceName: string
  ) => void;
  onModifyShared?: (
    sharedResourceId: string,
    sharedResourceName: string
  ) => void;
  onRevokeShared?: (sharedResourceId: string) => void;
  strategyTarget?: SignalBlockTarget;
};

export const ManageTradingTemplates: FC<ManageTradingTemplatesProps> = ({
  templateType,
  onApply,
  onAdd,
  onDelete,
  onSetAsDefault,
  onModify,
  onDuplicate,
  onShare,
  onImportShared,
  onModifyShared,
  onRevokeShared
}) => {
  return (
    <Box sx={{ height: '100%' }}>
      <SharedResourceTabs
        sharedResourceType="template"
        sharedTemplateType={templateType}
        onImportShared={onImportShared}
        onModifyShared={onModifyShared}
        onRevokeShared={onRevokeShared}
        renderMine={() => (
          <TemplateGrid
            templateType={templateType}
            onApply={onApply}
            onAdd={onAdd}
            onDelete={onDelete}
            onSetAsDefault={onSetAsDefault}
            onModify={onModify}
            onDuplicate={onDuplicate}
            onShare={onShare}
          />
        )}
      />
    </Box>
  );
};
